//libs
import clsx from "clsx";
import { Outlet } from "react-router-dom";
//styles
import "styles/tailwind.css";
//components
import Header from "./Header";
import Footer from "./Footer";

export const metadata = {
  title: {
    template: "%s - TaxPal",
    default: "TaxPal - Accounting made simple for small businesses",
  },
  description:
    "Most bookkeeping software is accurate, but hard to use. We make the opposite trade-off, and hope you don’t get audited.",
};

export default function RootLayout() {
  return (
    <div
      lang="en"
      className={clsx("h-full scroll-smooth bg-white antialiased text-gray-600")}
    >
      {/* <main className="flex h-full flex-col"> */}
        <Header />
        <Outlet />
        <Footer />
      {/* </main> */}
    </div>
  );
}
